module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_2_ECOSISTEMICO.bf245349.jpg";